var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrangeCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM18.35 14.1C18.31 14.19 18.26 14.27 18.19 14.34L15.15 17.38C15 17.53 14.81 17.6 14.62 17.6C14.43 17.6 14.24 17.53 14.09 17.38C13.8 17.09 13.8 16.61 14.09 16.32L15.85 14.56H7.35C6.94 14.56 6.6 14.22 6.6 13.81C6.6 13.4 6.94 13.06 7.35 13.06H17.66C17.76 13.06 17.85 13.08 17.95 13.12C18.13 13.2 18.28 13.34 18.36 13.53C18.42 13.71 18.42 13.92 18.35 14.1ZM17.65 10.93H7.35C7.25 10.93 7.15 10.91 7.06 10.87C6.88 10.79 6.73 10.65 6.65 10.46C6.57 10.28 6.57 10.07 6.65 9.89C6.69 9.8 6.74 9.72 6.81 9.65L9.85 6.61C10.14 6.32 10.62 6.32 10.91 6.61C11.2 6.9 11.2 7.38 10.91 7.67L9.16 9.43H17.66C18.07 9.43 18.41 9.77 18.41 10.18C18.41 10.59 18.07 10.93 17.65 10.93Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeCircleIcon);
export default __webpack_public_path__ + "static/media/arrange-circle-icon.9f1df1367137f05fd53ed67c248036eb.svg";
export { ForwardRef as ReactComponent };